import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-left\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.9999 19.4141L3.58567 11.9998L10.9999 4.58564L12.4141 5.99985L7.41409 10.9998H20.4999V12.9998H7.41409L12.4141 17.9998L10.9999 19.4141Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol